export default {
	namespaced: true,
	state: {
		widget: {},
	},

	mutations:{
		setWidget(state, payload) {
			state.widget = payload
		},
	},
	getters:{
		widget(state) {
			return state.widget
		}
	},
	actions: {

	},

}